import React, { createContext, useContext, useMemo } from 'react';
import { useLSStates } from '../Hooks/useLSStates';

const LSContext = createContext<any>(null);

export const LSProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const lsStates = useLSStates();
    return (
        <LSContext.Provider value={lsStates}>
            {children}
        </LSContext.Provider>
    );
};

export const useLSContext = () => {
    const context = useContext(LSContext);
    if (!context) {
        throw new Error('useLSContext must be used within a LSProvider');
    }
    return context;
};